/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type UpdateCompanyInternalDataInput = {
    companyId: number;
    trialEndYear?: number | null | undefined;
    trialEndMonth?: number | null | undefined;
    trialEndDay?: number | null | undefined;
    tier?: TierType | null | undefined;
    accessBlocked?: boolean | null | undefined;
    name?: string | null | undefined;
    street?: string | null | undefined;
    zip?: string | null | undefined;
    city?: string | null | undefined;
    country?: string | null | undefined;
    vatId?: string | null | undefined;
    contactName?: string | null | undefined;
    contactPhone?: string | null | undefined;
    contactEmail?: string | null | undefined;
    seats?: number | null | undefined;
    virtualSeats?: number | null | undefined;
    sisenseViewerSeats?: number | null | undefined;
    sisenseDesignerSeats?: number | null | undefined;
    syncWithSF?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateCompanyInternalDataMutationVariables = {
    input: UpdateCompanyInternalDataInput;
};
export type updateCompanyInternalDataMutationResponse = {
    readonly UpdateCompanyInternalData: {
        readonly MissionControlCompanyStats: {
            readonly id: string;
            readonly companyId: number | null;
            readonly companyName: string | null;
            readonly tier: TierType | null;
            readonly trialEndDate: string | null;
            readonly numOfProjects: number | null;
            readonly numOfCards: number | null;
            readonly numActivePersons: number | null;
            readonly numTimeRegs: number | null;
            readonly accessBlocked: boolean | null;
            readonly userSeats: number | null;
            readonly virtualSeats: number | null;
            readonly numOfClientUsers: number | null;
            readonly numVirtualUsers: number | null;
            readonly sisenseViewerSeats: number | null;
            readonly sisenseDesignerSeats: number | null;
        } | null;
    } | null;
};
export type updateCompanyInternalDataMutation = {
    readonly response: updateCompanyInternalDataMutationResponse;
    readonly variables: updateCompanyInternalDataMutationVariables;
};



/*
mutation updateCompanyInternalDataMutation(
  $input: UpdateCompanyInternalDataInput!
) {
  UpdateCompanyInternalData(input: $input) {
    MissionControlCompanyStats {
      id
      companyId
      companyName
      tier
      trialEndDate
      numOfProjects
      numOfCards
      numActivePersons
      numTimeRegs
      accessBlocked
      userSeats
      virtualSeats
      numOfClientUsers
      numVirtualUsers
      sisenseViewerSeats
      sisenseDesignerSeats
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCompanyInternalDataInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCompanyInternalDataPayload",
    "kind": "LinkedField",
    "name": "UpdateCompanyInternalData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlCompanyStatsType",
        "kind": "LinkedField",
        "name": "MissionControlCompanyStats",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trialEndDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numOfProjects",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numOfCards",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numActivePersons",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numTimeRegs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accessBlocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userSeats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "virtualSeats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numOfClientUsers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numVirtualUsers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sisenseViewerSeats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sisenseDesignerSeats",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCompanyInternalDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCompanyInternalDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateCompanyInternalDataMutation",
    "operationKind": "mutation",
    "text": "mutation updateCompanyInternalDataMutation(\n  $input: UpdateCompanyInternalDataInput!\n) {\n  UpdateCompanyInternalData(input: $input) {\n    MissionControlCompanyStats {\n      id\n      companyId\n      companyName\n      tier\n      trialEndDate\n      numOfProjects\n      numOfCards\n      numActivePersons\n      numTimeRegs\n      accessBlocked\n      userSeats\n      virtualSeats\n      numOfClientUsers\n      numVirtualUsers\n      sisenseViewerSeats\n      sisenseDesignerSeats\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f5fa99b86fb30c2c686911606f116e7c';
export default node;
